import React from "react";
import {Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import BackButton from '../Common/BackButton'
import {useTranslation} from "react-i18next";
import RegistrationServiceButton from "./RegistrationServiceButton";
import SpecialInspectionButton from "./SpecialInspectionButton";

interface OtherServiceSelectorProps {
    onSelect: (action: string) => void
}

const OtherServiceSelector = ({ onSelect }: OtherServiceSelectorProps) => {
    const { t } = useTranslation()

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={2} className={'pageMainContainer'}>
            <Grid className="pageMainHeader">
                <Typography variant="h4">
                    {t('selfService.selectService')}
                </Typography>
            </Grid>
            <Grid size="grow" justifyItems="center" alignContent="center" style={{width: '100%', textAlign: 'center'}}>
                <Stack direction="column" spacing={2} maxWidth="90%" width={800} style={{margin: 'auto'}}>
                    <RegistrationServiceButton handleSelect={onSelect} />
                    <SpecialInspectionButton handleSelect={onSelect} />
                </Stack>
            </Grid>
            <Grid className="footerButtons">
                <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                    <Grid>
                        <BackButton onBack={() => window.location.reload()} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default OtherServiceSelector
